module.exports = __webpack_public_path__ + "img/秋季博览会.88f9a7df.jpg";